// import package
import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import DataTable from 'react-data-table-component';
import { Select, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
// import action
import { getTrnxHistory } from '../../actions/walletAction'

// import lib
import isEmpty from '../../lib/isEmpty';
import { transactionStatus } from '../../lib/displayStatus';
import { dateTimeFormat } from '../../lib/dateTimeHelper'

const columns = [
    {
        name: 'Date',
        selector: 'date',
        sortable: false,
        width : '150px'
    },
    {
        name: 'Type',
        selector: 'type',
        sortable: false,
        width: '100px',
    },
    {
        name: 'Currency',
        selector: 'currency',
        sortable: false,
        width: '100px',
    },
    {
        name: 'Amount',
        selector: 'amount',
        sortable: false,
        width: '100px',
    },
    {
        name: 'Transaction Ref.',
        selector: 'transRef',
        sortable: false,
        width: '370px',
    },
    // {
    //     name: 'Bank & Account',
    //     selector: 'bankAccount',
    //     sortable: false,
    // },
    {
        name: 'Status',
        selector: 'status',
        sortable: false,
    },
];

const FiatHistory = (props) => {
    // props
    const { currencyOption } = props;
    const { t, i18n } = useTranslation();
    // state
    const [loader, setLoader] = useState(false)
    const [record, setRecord] = useState({
        'data': [],
        'count': 0
    })
    const [filter, setFilter] = useState({
        'coin': 'all',
        'type': 'all',
        'status': 'all',
        'amount': '',
        'page': 1,
        'limit': 10
    })
    const [typingTimeout, setTypingTimeout] = useState(0)

    const { coin, type, amount, status } = filter

    // function
    const fetchHistory = async (reqQuery) => {
        try {
            setLoader(true)
            const { status, loading, result } = await getTrnxHistory('fiat', reqQuery)
            setLoader(loading)
            if (status == 'success') {
                if (result && result.data && result.data.length > 0) {
                    let resultArr = []
                    result.data.map((item) => {
                        resultArr.push({
                            'date': dateTimeFormat(item.createdAt, 'YYYY-MM-DD HH:mm'),
                            'type': transactionStatus(item.paymentType),
                            'currency': item.coin,
                            'amount': item.amount,
                            'transRef': item._id,
                            'bankAccount': isEmpty(item.bankDetail) ? '-' : `${item.bankDetail.bankName}-${item.bankDetail.accountNo}`,
                            'status': <div className="textStatusGreen">{item.status}</div>
                        })

                        //textStatusOrange,textStatusGreen
                    })
                    setRecord({
                        'data': resultArr,
                        count: result.count
                    })
                } else {
                    setRecord({
                        'data': result.data,
                        'count': result.count
                    })
                }
            }
        } catch (err) { }
    }

    const handlePageChange = page => {
        let filterData = { ...filter, ...{ 'page': page } }
        setFilter(filterData)
        fetchHistory(filterData)
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        let filterData = { ...filter, ...{ 'page': page, 'limit': newPerPage } }
        setFilter(filterData)
        fetchHistory(filterData)
    };

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        let filterData = {
            ...filter,
            [name]: value
        }
        console.log(filterData)
        setFilter(filterData)
        if (name == 'amount') {
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
            setTypingTimeout(setTimeout(function () {
                fetchHistory(filterData)
            }, 1000))
        } else {
            fetchHistory(filterData)
        }
    }


    useEffect(() => {
        fetchHistory(filter)
    }, [])

    return (
        <div className="dashboard_box stakingHistoryTable">
            <div className="newUsersFilter contact_form settingsSelect mb-0 historyPageFilter">
                <div className="newsSelectGroup">
                    <label>{t('FILTER_BY')}</label>
                    <Select
                        value={type}
                        name="type"
                        onChange={handleChange}
                    >
                        <MenuItem value={'all'}>{t('ALL')}</MenuItem>
                        <MenuItem value={'withdraw'}>{t('WITHDRAW')}</MenuItem>
                        <MenuItem value={'deposit'}>{t('DEPOSIT')}</MenuItem>
                        {/*<MenuItem value={'transfer'}>{t('TRANSFER')}</MenuItem>*/}
                    </Select>
                    <Select
                        className="marginSpace"
                        value={coin}
                        name="coin"
                        onChange={handleChange}
                    >
                        <MenuItem value={'all'}>{t('ALL')}</MenuItem>
                        {
                            currencyOption && currencyOption.length > 0 && currencyOption.map((item, key) => {
                                if (item.type == 'fiat') {
                                    return (
                                        <MenuItem value={item.coin} key={key}>
                                            {item.coin}
                                        </MenuItem>
                                    )
                                }
                            })
                        }
                    </Select>
                    <Select
                        className="marginSpace"
                        value={status}
                        name="status"
                        onChange={handleChange}
                    >
                        <MenuItem value={'all'}>{t('ALL')}</MenuItem>
                        <MenuItem value={'pending'}>{t('PENDING')}</MenuItem>
                        <MenuItem value={'completed'}>{t('COMPLETED')}</MenuItem>
                        <MenuItem value={'rejected'}>{t('REJECTED')}</MenuItem>
                    </Select>
                    <div className="tableSearchBox">
                        <div class="input-group">
                            <input
                                type="text"
                                name="amount"
                                value={amount}
                                onChange={handleChange}
                                class="form-control"
                                placeholder="Search by amount"
                            />
                            <div class="input-group-append">
                                <span class="btnType1"><i class="fas fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="newsSelectGroup">
                    <button className="btn btn-outline text-uppercase py-1 m-0">Download PDF</button>
                </div> */}
            </div>
            <DataTable
                columns={columns}
                data={record.data}
                paginationTotalRows={record.count}
                noHeader
                progressPending={loader}
                pagination
                paginationServer
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
            />
        </div>
    )
}

FiatHistory.propTypes = {
    currencyOption: PropTypes.array.isRequired
};

FiatHistory.defaultProps = {
    currencyOption: [],
};

export default FiatHistory;